<div class="overlay-inner-wrapper">
  @if (!isInspektion()) {
    <header class="header-2">
      <div class="branding">
        <span class="title">{{ 'Ereignisse verwalten' | mrTranslate }} • {{ bezeichnung() }}</span>
      </div>
      <div class="header-actions">
        <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
          <cds-icon shape="times"/>
        </a>
      </div>
    </header>
  }
  <div
    id="bauwerksWrapper"
    class="w-100-p padding-10-lr padding-12-b scroll-y"
    [ngClass]="isInspektion() ? 'h-100' : 'h-60'">
    <div class="clr-row nxm clr-justify-content-end">
      <div class="clr-col-auto margin-12-tb">
        <div class="btn-group btn-primary btn-icon">
          <button
            class="btn btn-icon btn-success"
            [title]="'Neu' | mrTranslate"
            (click)="addEreignis()"
            [disabled]="isModeNew()">
            <cds-icon shape="file" />
          </button>
          <button
            class="btn btn-icon btn-danger"
            [title]="'Löschen' | mrTranslate"
            [disabled]="!selectedNatur()"
            (click)="deleteTitelEreignis()">
            <cds-icon shape="times" />
          </button>

          <button
            type="submit"
            form="naturschutz-form"
            class="btn btn-icon margin-12-l"
            [clrLoading]="saveState()"
            [title]="'Speichern' | mrTranslate"
            [disabled]="!(selectedNatur() || isModeNew())">
            <cds-icon shape="floppy" />
          </button>
        </div>
      </div>
    </div>
    <form
      id="naturschutz-form"
      [formGroup]="formEreignisTop"
      (ngSubmit)="saveIfValid()"
      [clrLabelSize]="12"
      clrForm
      clrLayout="vertical"
      class="width100 padding-12-lr margin--35-t">
      @if (formEreignisTop.errors?.['not-in-Direction']; as err) {
        <div class="clr-row nxm clr-col-12 clr-col-sm-10 clr-col-md-8 clr-col-lg-6">
          <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
            <clr-alert-item>
              <span class="alert-text">
                {{
                  'Die Position kann nicht ' + (err.upwards ? 'größer' : 'kleiner') + ' als der Endmeter sein'
                    | mrTranslate
                }}
              </span>
            </clr-alert-item>
          </clr-alert>
        </div>
      }
      <div class="clr-row nxm">
        <div class="clr-col-md-2 clr-col-sm-4 clr-col-6" [class.clr-order-2]="drehung.isOn">
          <clr-input-container>
            <label for="von" class="clr-required-mark">
              {{ 'Position' | mrTranslate }}
              <div
                class="btn-group btn-sm btn-icon btn-outline"
                style="margin-left: 10px; margin-top: -7px; float: inline-end">
                <button
                  class="btn"
                  type="button"
                  [title]="'Geoposition orten' | mrTranslate"
                  tabindex="-1"
                  (click)="findPositionAndAutofill()"
                  [disabled]="formEreignisTop.disabled"
                          [clrLoading]="geoState()">
                  <cds-icon shape="map-marker" />
                </button>
              </div>
            </label>

            <input
              type="number"
              clrInput
              formControlName="position"
              [value]="formEreignisTop.controls.position.value | drehung: drehung.summe"
              (change)="
                formEreignisTop.controls.position.setValue(drehungPipe.back($event.target.value, drehung.summe))
              "
              [step]="0.1"
              [attr.placeholder]="minMeter()" />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
            @if (formEreignisTop.controls.position.errors?.min; as err) {
              <clr-control-error>
                {{ 'Der Wert ist ' + (!drehung.isOn ? 'kleiner' : 'größer') + ' als' | mrTranslate }}
                {{ err.min | drehung: drehung.summe }}
              </clr-control-error>
            }
            @if (formEreignisTop.controls.position.errors?.max; as err) {
              <clr-control-error>
                {{ 'Der Wert ist ' + (!drehung.isOn ? 'größer' : 'kleiner') + ' als' | mrTranslate }}
                {{ err.max | drehung: drehung.summe }}
              </clr-control-error>
            }
          </clr-input-container>
        </div>
        <div class="clr-col-md-3 clr-col-sm-4 clr-col-6 clr-order-3">
          <clr-control-container>
            <label class="clr-required-mark">{{ 'Typ' | mrTranslate }}</label>
            <app-datalist-input [datalist]="typListe()" placeholder="" formControlName="typ" />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
          </clr-control-container>
        </div>
        <div class="clr-col-md-3 clr-col-sm-5 clr-col-6 clr-order-3">
          <clr-control-container>
            <label>{{ 'Beschreibung' | mrTranslate }}</label>
            <app-datalist-input [datalist]="beschreibungListe()" placeholder="" formControlName="beschreibung" />
          </clr-control-container>
        </div>
        <div class="clr-col-md-4 clr-col-sm-5 clr-col-6 clr-order-3">
          <clr-input-container>
            <label for="bemerkung">{{ 'Bemerkung' | mrTranslate }}</label>
            <input type="text" clrInput name="bemerkung" formControlName="bemerkung" />
          </clr-input-container>
        </div>
      </div>
    </form>
    @if (table().columns.length) {
      <clr-datagrid
        class="datagrid-compact dg-overflow-fix"
        style="max-height: calc(100svh - 400px)"
        [clrDgItemsIdentityFn]="row => row?.id"
        [clrDgRowSelection]="true"
        [clrDgSelectionType]="'single'"
        [clrDgSelected]="[selectedNatur()]"
        (clrDgSelectedChange)="selectedNatur.set($event[0])">
        <clr-dg-column [clrDgField]="'position'" [clrDgSortOrder]="direction() * (drehung.isOn ? -1 : 1)">
          {{ 'Position' | titlecase | mrTranslate }}
        </clr-dg-column>

        @for (column of table().columns | array: 'filter' : exceptStartEnd; track column.id) {
          <clr-dg-column [clrDgField]="column.id">
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['id', 'ostammid', 'bild'] }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }

        <clr-dg-row *clrDgItems="let row of table().rows" [clrDgItem]="row">
          <clr-dg-cell class="name-cell">
            {{ row[!drehung.isOn ? 'position' : 'position'] | drehung: drehung.summe | tablePrettyPrint }}
          </clr-dg-cell>
          @for (cell of table().columns | array: 'filter' : exceptStartEnd; track cell.id) {
            <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
          }
        </clr-dg-row>
        <clr-dg-footer>{{ table().rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }

    <div class="clr-row nxm padding-24-b">
      <div class="clr-col-12">
        <app-preview-thumbnails
          [readonly]="!(selectedNatur() || isModeNew())"
          [acceptTypes]="'image/*'"
          [maxAmount]="6"
          (deleteFile)="deleteFile($any($event))"
          [allowCameraVideo]="false" />
      </div>
    </div>
  </div>
</div>
